<template>
  <div>
    <v-container>
      <!-- <div>
        <date-filter
          @changeDate="getData"
          :defaultFilter="'today'"
          v-model="selectedDate"
        ></date-filter>
      </div> -->
      <div class="mt-3">
        <div class="title mb-3">จำนวนและรายชื่อจังหวัดที่ช่างอยู่</div>
        <v-layout row wrap class="mb-0">
          <v-flex xs6>
            <!-- <div>
              <multiselect
                v-model="dealertype"
                label="label"
                :allow-empty="false"
                single-select
                :options="optionType"
                @input="getData"
              ></multiselect>
            </div> -->
          </v-flex>
          <v-flex xs6 class="pt-3">
            <!-- <div class="text-xs-right">ทั้งหมด : {{ total }}</div> -->
          </v-flex>
        </v-layout>

        <v-data-table
          v-bind:pagination.sync="pagination"
          :headers="headers"
          :items="data"
          class="elevation-1"
          hide-actions
          :loading="loading"
        >
          <template v-slot:items="props">
            <tr>
              <td class="text-xs-center pa-3">
                {{ props.item.province }}
              </td>
              <td class="text-xs-center pa-3">
                {{ props.item.total }}
              </td>
            </tr>
          </template>
        </v-data-table>
      </div>
    </v-container>
  </div>
</template>

<script>
import api from '@/api'
import DateFilter from '@/components/view/dashboard/DateFilter.vue'
import { mapGetters } from 'vuex'
import moment from 'moment'
import Multiselect from 'vue-multiselect'
export default {
  components: {
    DateFilter,
    Multiselect
  },
  data() {
    return {
      dealertype: {
        label: 'ร้านค้าที่ส่งใบประเมินราคาให้ลูกค้า',
        value: 'dealersendquotationdashboard'
      },
      optionType: [
        {
          label: 'ร้านค้าที่ส่งใบประเมินราคาให้ลูกค้า',
          value: 'dealersendquotationdashboard'
        },
        {
          label: 'ร้านค้าที่การชำระเงินสำเร็จ',
          value: 'dealersendquotationdashboard'
        },
        {
          label: 'ร้านค้าที่จัดส่งสำเร็จ',
          value: 'dealersendquotationdashboard'
        },
        {
          label: 'ร้านค้าที่ลงทะเบียนสำเร็จ',
          value: 'dealersendquotationdashboard'
        }
      ],
      loading: false,
      selectedDate: {
        start: moment().format('YYYY-MM-DD'),
        end: moment().format('YYYY-MM-DD')
      },
      pagination: { sortBy: 'none', descending: true, rowsPerPage: 25 },
      data: [],
      total: 0,
      headers: [
        { text: 'จังหวัด', value: 'province', align: 'center', width: '1%' },
        { text: 'จำนวน', value: 'total', align: 'center', width: '1%' }
      ]
    }
  },
  computed: {
    ...mapGetters(['selectedBot'])
  },
  async mounted() {
    await this.getData()
  },
  methods: {
    onChangeType() {},
    getData() {
      return new Promise((resolve) => {
        var data = {
          pageid: this.selectedBot.pageid,
          datefrom: moment(this.selectedDate.start).format('YYYY-MM-DD'), // YYYY-MM-DD
          dateto: moment(this.selectedDate.end).format('YYYY-MM-DD') // YYYY-MM-DD
        }
        this.loading = true
        api['provincepainterdashboard'](data, (err, response) => {
          this.loading = false
          this.data = response.data
          if (response.total) {
            this.total = response.total
          } else {
            this.total = 0
          }
          resolve()
        })
      })
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/toa/Painter/provincepainterdashboard.vue